<template>
  <v-select
    id="solution-select"
    v-model="filter.municipioTarefa"
    item-text="nome"
    item-value="municipioTarefaId"
    :items="filter.tasks"
    label="Tarefa"
    placeholder="Tarefa"
    :return-object=true
    @change="$emit('changeTask')"
  >
    <template slot="no-data">
      Nenhuma Tarefa retornada
    </template>
  </v-select>
</template>

<script>
export default {
  name: 'AppCityTaskCombobox',
  props: [
    'filter'
  ]
}
</script>
